import { Group, Stack, Text, ThemeIcon, Title } from "@mantine/core";
import type { IconProps } from "@tabler/icons-react";
import type { ComponentType, ReactNode } from "react";

interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
  icon?: ComponentType<IconProps>;
  breadcrumb?: ReactNode;
}

export function PageHeader({ title, subtitle, actions, icon: Icon, breadcrumb }: PageHeaderProps) {
  return (
    <Stack gap="var(--axio-unit-6)">
      {breadcrumb}
      <Group justify="space-between" align="flex-start" wrap="wrap" gap="md">
        <Stack gap="var(--axio-unit-6)" style={{ flex: "var(--axio-number-one)", minWidth: "var(--axio-unit-0)" }}>
          <Group gap="sm" wrap="nowrap" align="center">
            {Icon && (
              <ThemeIcon size="var(--axio-unit-36)" variant="light" color="violet">
                <Icon size="var(--axio-unit-18)" stroke="var(--axio-stroke-width-subtle)" />
              </ThemeIcon>
            )}
            <Title order={2}>{title}</Title>
          </Group>
          {subtitle != null && (
            <Text c="dimmed" maw="var(--axio-unit-640)">
              {subtitle}
            </Text>
          )}
        </Stack>
        {actions != null && <Group gap="sm">{actions}</Group>}
      </Group>
    </Stack>
  );
}
